import React, { useEffect, useRef, useState } from "react";
import Zoom from "@mui/material/Zoom";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import classes from "./MUIToolTip.module.css";
import Sources from "./Sources";
import api from "../../../BrandOnBoarding/api";
import MUIButton from "../MUIButton/MUIButton";
import Spinner from "../../Spinner/Spinner";
import LoadingSkeleton from "./LoadingSkeleton";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#353945",
    color: "#FCFCFD",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    maxWidth: 500,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#353945",
  },
}));

const getTruncatedText = (summary) => {
  const words = summary?.split(" ");
  return words?.slice(0, 30).join(" ") + (words?.length > 50 ? "...." : "");
};

export default function MUIToolTip({
  sources = [],
  actionText = "",
  children,
  title,
  metric,
  metricScore,
  addToActionHandler,
  attribute,
  selectedInput,
  targetKey,
  isActionLoading,
  realtimeSources,
  isBrandOverview = false,
  rating,
  sourceData,
  ...props
}) {
  const llmSources =
    sources && Object.values(sources)?.[0]
      ? Object.keys(Object.values(sources)[0]).slice(0, 5)
      : [];
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [source, setSource] = useState([]);
  const [realTimesource, setRealTimeSource] = useState([]);
  const abortCtrlRef = useRef();
  useEffect(() => {
    if (realtimeSources) {
      if (!open) {
        if (abortCtrlRef.current) {
          abortCtrlRef.current.abort();
        }
        setSource([]);
        return;
      }

      var timer = setTimeout(() => {
        getSources();
      }, 0);
    } else {
      setSource(llmSources);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open]);

  async function getSources() {
    abortCtrlRef.current = new AbortController();
    let sources = llmSources;
    try {
      setLoading(true);
      const metricName = metric;
      const response = await realtimeSources(attribute, metricName);
      if (response.length > 0) {
        setRealTimeSource(response);
        sources = response;
      }
    } catch (error) {
    } finally {
      setSource(sources);
      setLoading(false);
    }
  }
  useEffect(() => {
    if (!open) {
      if (abortCtrlRef.current) {
        abortCtrlRef.current.abort();
      }
      setSource([]);
      return;
    }
    const timer = setTimeout(() => {
      getSources();
    }, 1000);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open]);

  // async function getSources() {
  //   abortCtrlRef.current = new AbortController();
  //   const additionalText = `${selectedInput.brand} received a rating of ${metricScore} out of 10, a ${rating} score in ${attribute}`
  //   try {
  //     setLoading(true);
  //     const payload = {
  //       text_content: `
  //         ${additionalText}

  //         AdditionInfo: ${title}
  //         `,
  //     };
  //     const response = await api.post("/metrics/sources", payload, {
  //       signal: abortCtrlRef.current.signal,
  //     });
  //     setSource(response.data.citations);
  //   } catch (error) {
  //     console.error("error occur in getSources", error)
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  function handleTooltipOpen() {
    setOpen(true);
  }

  function handleTooltipClose() {
    setOpen(false);
  }

  function ToolTipContent({ actionText }) {
    const entity = selectedInput?.brand
      ? `brand ${selectedInput?.brand}`
      : `product ${selectedInput?.product}`;
    const actionStatement = `The ${metric}-${attribute} score for the ${entity} is ${metricScore}`;

    return (
      <div className={classes.content}>
        <h6>{typeof title === "string" ? getTruncatedText(title) : actionStatement}</h6>
        <h6>Training Data Sources</h6>
        {sourceData?.length > 0 && (
          <>
            <span className="mb-2">{selectedInput?.llm}</span>
            <Sources sources={sourceData} />
          </>
        )}
        <span className="mb-2">Online</span>
        {realtimeSources && loading && <LoadingSkeleton />}
        {source?.length > 0 && <Sources sources={source} />}

        <div className={classes.action_btn_wrapper}>
          {isActionLoading ? (
            <Spinner />
          ) : (
            <MUIButton
              size="small"
              className={classes.action_btn}
              variant="outlined"
              onClick={() => {
                isBrandOverview
                  ? addToActionHandler(actionStatement, title, realTimesource)
                  : addToActionHandler(
                    actionStatement,
                    title,
                    sources,
                    targetKey,
                    realTimesource
                  );
              }}
            >
              {actionText}
            </MUIButton>
          )}
        </div>
      </div>
    );
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className={classes.tooltip_wrapper}>
        <LightTooltip
          open={open}
          onOpen={handleTooltipOpen}
          onClose={handleTooltipClose}
          slots={{
            transition: Zoom,
          }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClick={() => setOpen(true)}
          title={<ToolTipContent actionText={actionText} />}
          {...props}
        >
          {children}
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}
